module.exports = __webpack_public_path__ + "img/085.70ad9925.png";